import { ResponsiveLayout } from '@milestone-portal/ui/ResponsiveLayout/ResponsiveLayout';

import { DesktopNftDetailSkeleton } from './DesktopNftDetailSkeleton';
import { MobileNftDetailSkeleton } from './MobileNftDetailSkeleton';

export function NftDetailSkeleton() {
  return (
    <ResponsiveLayout
      desktop={<DesktopNftDetailSkeleton />}
      mobile={<MobileNftDetailSkeleton />}
    />
  );
}
